import React, { useEffect, useState, memo } from 'react';
import { ClockIcon } from 'lucide-react';
export const CountdownBar = memo(function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState(850);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const timeDisplay = `00:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-black text-white py-2 px-4 shadow-lg border-b-4 border-red-600" data-id="element-38">
      <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 text-sm md:text-base font-bold text-center" data-id="element-39">
        <div className="flex items-center gap-2 text-yellow-400" data-id="element-40">
          <ClockIcon className="w-5 h-5 animate-pulse" data-id="element-41" />
          <span data-id="element-42">⏰ OFERTA EXPIRA EN</span>
        </div>
        <div className="text-2xl md:text-3xl font-black tracking-widest text-white" data-id="element-43">
          {timeDisplay}
        </div>
        <div className="bg-red-600 text-white px-3 py-1 rounded-full animate-pulse" data-id="element-44">
          ⚡ ÚLTIMOS CUPOS DISPONIBLES
        </div>
      </div>
    </div>;
});